import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Photo from 'app/models/photo';
import { InlineCarouselOptions } from 'app/models/inline-carousel';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'inline-carousel',
  templateUrl: './inline-carousel.component.html',
  styleUrls: ['./inline-carousel.component.scss']
})
export class InlineCarouselComponent implements OnInit {


  @Input() alt: string;
  @Input() photos: Photo[];
  @Input() inlineCarouselOptions: InlineCarouselOptions;
  // @ViewChild('swiper') swiper: SwiperComponent

  // Should be used in conjunction, gives image a hover effect
  @Output() clickedIndex = new EventEmitter<number>();
  isExpandable: boolean = false;

  imageHeight: number;
  useThumb: boolean
  // imageResolution: string = 'original_url';
  swiperIndex = Math.floor(Math.random() * 9e6) + 1e6;

  sliderConfig: SwiperOptions = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 3,
    // Swiper is apparently getting initialized before the page is ready and it cannot
    // determine the correct size of the inital images on first page load. Setting this
    // to true tells Swiper to watch for changes and update itself accordingly.
    observer: true,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true
    },
    navigation: {
      prevEl: '.navigation-prev-' + this.swiperIndex,
      nextEl: '.navigation-next-' + this.swiperIndex
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true
    },
    breakpoints: {
      0 : { slidesPerView: 1 },
      500: { slidesPerView: 2 },
      1064: { slidesPerView: 3 },
    }
  };

  constructor() { }

  ngOnInit() {
    if (!this.inlineCarouselOptions) {
      return;
    }

    const { imageHeight, useThumb, isExpandable, ...optionsForConfig } = this.inlineCarouselOptions;
    this.imageHeight = imageHeight;
    this.useThumb = useThumb

    if(isExpandable) {
      this.isExpandable = isExpandable;
    }

    this.sliderConfig = {
      ...this.sliderConfig,
      ...optionsForConfig as any
    };
  }

  expandThisPhoto(event: Event) {
    // It appears Swiper does not correctly calculate the clicked index
    // when using multiple imagesPerView. Just track it manually via an index
    // on the slide element itself.
    const target = event.currentTarget as HTMLElement;
    const index = parseInt(target.dataset.index);
    this.clickedIndex.emit(index);
  }
}
